// extracted by mini-css-extract-plugin
export default {"article-intro":"Ox1i3v"};